import { render, staticRenderFns } from "./BorderSegmentSettings.vue?vue&type=template&id=79ac7376&scoped=true&lang=html&"
import script from "./BorderSegmentSettings.vue?vue&type=script&lang=js&"
export * from "./BorderSegmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./BorderSegmentSettings.vue?vue&type=style&index=0&id=79ac7376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac7376",
  null
  
)

export default component.exports